import React from 'react'
import OrdersList from '../components/Orders/OrdersList';

 const Orders = ({ orders, phone_screen }) => {
    return (
        <>
            <OrdersList orders={orders} phone_screen={phone_screen} />
        </>
    )
}


export { Orders as default };
